<template>
	<div id="yhkgl">
		<div class="yhkgl_main" v-show="!showBind">
			<div class="czTable">
				<!-- <div class="notice">
					<span class="iconfont">&#xe6df;</span>添加或修改绑定的银行卡，需要1小时后才能进行提现。
				</div> -->
				<el-table :data="tableData" border style="width: 100%">
					<!-- 判断有没有银行卡的时候 显示 -->
					<div class="none_card" v-show="!isBind && lockedState == false" slot="empty">
						<div class="none_card_box">
							<span style="margin-right: 10px">您暂未绑定银行卡，点击</span>
							<el-button type="primary" class="blue" @click="addBankCart">立即绑定</el-button>
						</div>
					</div>
					<el-table-column prop="BankName" label="开户银行" align="center" width="120" />
					<el-table-column prop="FullName" label="姓名" align="center" width="80" />
					<el-table-column prop="BankNumber" label="银行卡号" align="center" width="120" />
					<el-table-column prop="address" label="地址" align="center" />
					<el-table-column prop="BankBranch" label="支行名称" align="center" />
					<el-table-column prop="CreateTime" label="日期" align="center" width="180" />
				</el-table>
			</div>

			<div class="bottom" v-if="isBind || lockedState == true" v-show="bindTipsShow">
				<div v-if="lockedState == false" class="bottom_top">
					<div class="tips_bind"></div>
					<p class="bottom_ts_text">{{ bindTips }}</p>
					<span class="blue" v-if="tableData.length < 10" @click="addBankCart">添加银行卡</span>
				</div>
				<div v-else class="tips lock">
					<div class="tips_bind"></div>
					<p class="bottom_ts_text">{{ bindTips }}</p>
					<span class="bottom_ts_text" style="margin-left: 10px"
						><a class="blue" :href="kfUrl" target="_blank">已锁定，点击联繫客服解锁</a></span
					>
				</div>
				<i class="el-icon-close oranges" @click="bindTipsShow = false"></i>
			</div>
			<div class="yhkgl_top">
				<div class="wxts_text">
					<p class="wxts">温馨提示：</p>
					<p class="list">1、银行卡的开户名必须和实名认证的一致。</p>
					<p class="list">2、最多只能添加10张银行卡。</p>
					<p class="list">3、如需修改或删除银行卡账号请联系客服人员。</p>
				</div>
			</div>
		</div>
		<!-- 绑定银行卡 -->
		<div class="bindCart" v-show="showBind">
			<el-form ref="form" :model="form" label-width="150px">
				<el-form-item label="开户银行">
					<el-select v-model="form.Bid" placeholder="请选择">
						<el-option v-for="item in bankInfo" :key="item.Bid" :label="item.Name" :value="item.Bid" />
					</el-select>
				</el-form-item>
				<el-form-item label="开户人">
					<el-input v-model="userInfo.FullName" :disabled="true"></el-input>
				</el-form-item>
				<el-form-item label="开户地址">
					<el-select v-model="form.BankProvince" placeholder="请选择" @change="chooseProvince">
						<el-option v-for="item in provinceInfo" :key="item.Value" :label="item.Name" :value="item.Value" />
					</el-select>
					<el-select v-model="form.BankCity" placeholder="请选择" style="margin-top: 10px">
						<el-option v-for="item in cityInfo" :key="item.Value" :label="item.Name" :value="item.Value" />
					</el-select>
				</el-form-item>
				<el-form-item label="银行卡号">
					<el-input v-model.trim="form.BankNumber" />
				</el-form-item>
				<el-form-item label="支行名称">
					<el-input v-model.trim="form.BankBranch" />
				</el-form-item>
				<el-form-item label="资金密码">
					<el-input v-model.trim="form.SafetyPassWord" type="password" />
				</el-form-item>
				<el-form-item>
					<el-button type="primary btn_color" @click="onSubmit">立即添加</el-button>
					<el-button @click="onCancel">取消</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 完善姓名 -->
		<el-dialog title="提示" :visible.sync="dialogVisible">
			<div class="warning_img">
				<i class="el-icon-warning"></i>
			</div>
			<div style="text-align: center">您尚未设置真实姓名，请设置</div>
			<span slot="footer" class="dialog-footer">
				<el-button class="pop_sure_btn" type="primary" @click="goBindCart">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
// 引用axios封装文件
import { postAjax, getAjax } from "../../util/ajax.js";
import { SysKey } from "../../util/sysconfig";
export default {
	name: "yhkgl",
	data() {
		return {
			bindTipsShow: true,
			dialogVisible: false,
			walletCount: 0,
			tableData: [],
			//隐藏或显示绑定一张卡还是为绑定卡
			isBind: false,
			//银行列表信息
			bankInfo: [],
			//省份信息
			provinceInfo: [],
			//市信息
			cityInfo: [],
			//显示隐藏绑定银行卡
			showBind: false,
			form: {
				Bid: "",
				BankProvince: "",
				BankCity: "",
				BankNumber: "",
				BankBranch: "",
				SafetyPassWord: "",
			},
			userInfo: {},
			kfUrl: SysKey("KfCenterUrl").SysValue,
		};
	},
	computed: {
		bindTips() {
			return `您已经绑定${this.tableData.length}张银行卡`;
		},
		lockedState() {
			return this.$store.state.bankIslocking;
		},
	},
	created() {
		this.getBankList();
		this.getUserWalletCount();
		this.getAllInfo();
		this.$store.dispatch("getBankIslocking");
	},
	methods: {
		//获取绑定银行卡接口
		getBankList() {
			var url = "api/Bank/GetUserDrawBankList";
			postAjax(url).then(data => {
				if (data.IsSucess) {
					this.tableData = data.Data;
					//如果有数据就给他增加一个字段为地址address
					if (this.tableData.length > 0) {
						this.isBind = true;
						for (var i = 0, length = this.tableData.length; i < length; i++) {
							this.tableData[i].address = this.tableData[i].BankProvince + "--" + this.tableData[i].BankCity;
						}
					} else {
						this.isBind = false;
					}
				}
			});
		},
		//添加银行卡
		addBankCart() {
			if (this.walletCount >= 10) {
				return this.$message.error("最多只能添加10张银行卡或虚拟/数字钱包");
			}
			if (!this.userInfo.FullName) {
				this.dialogVisible = true;
			} else {
				this.showBind = true;
			}
		},
		//选择省份显示市级信息
		chooseProvince(val) {
			this.form.BankCity = "";
			let url = "/api/Sys/GetCitys?Province=" + val;
			postAjax(url, null).then(data => {
				if (data.IsSucess) {
					this.cityInfo = data.Data;
				}
			});
		},
		//立即创建
		onSubmit() {
			let cardNumValidity = this.checkCardNum();
			if (typeof cardNumValidity === "string") {
				return this.$message.error(cardNumValidity);
			}

			let url = "/api/Bank/AddUserBankInfo";
			const loading = this.$loading({ background: "rgba(255, 255, 255, 0.2)" });
			postAjax(url, this.form)
				.then(data => {
					if (data.IsSucess) {
						this.getBankList();
						this.getUserWalletCount();
						this.onCancel();
					} else {
						this.$message.error(data.Message);
						this.onCancel();
					}
				})
				.catch(err => {
					console.log("error", err);
				})
				.finally(() => {
					loading.close();
				});
		},
		onCancel() {
			this.showBind = false;
			this.form = {
				Bid: "",
				BankProvince: "",
				BankCity: "",
				BankNumber: "",
				BankBranch: "",
				SafetyPassWord: "",
			};
		},
		checkCardNum() {
			let bankno = this.form.BankNumber;
			let num = /^\d*$/; //全数字
			let strBin =
				"10,18,30,35,37,40,41,42,43,44,45,46,47,48,49,50,51,52,53,54,55,56,58,60,62,65,66,68,69,84,87,88,94,95,98,99"; //开头6位
			if (bankno == "") {
				return "请输入银行卡号";
			} else if (bankno.length < 16 || bankno.length > 19) {
				return "银行卡号长度必须在16到19之间";
			} else if (!num.exec(bankno)) {
				return "银行卡号必须全为数字";
			} else if (strBin.indexOf(bankno.substring(0, 2)) == -1) {
				return "银行卡号开头6位不符合规范";
			} else {
				return true;
			}
		},
		goBindCart() {
			this.$emit("routerChange", "grzl");
			this.dialogVisible = false;
		},
		getUserWalletCount() {
			let url = "/api/Bank/GetUserWalletCount"; // 取得卡片绑定数量
			getAjax(url)
				.then(data => {
					if (data.IsSucess) {
						this.walletCount = data.Data;
					} else {
						this.$message.error(data.Message);
					}
				})
				.catch(err => {
					console.log("error", err);
				});
		},
		getAllInfo() {
			let promises = [
				getAjax("api/Bank/GetBankListInfo"), //获取银行列表
				postAjax("api/Sys/GetProvince"), //获取省份信息
				postAjax("Api/User/GetUserInfo"), // 得到用户信息方法
			];

			Promise.all(promises)
				.then(items => {
					if (items[0].IsSucess) {
						this.bankInfo = items[0].Data;
					}
					if (items[1].IsSucess) {
						this.provinceInfo = items[1].Data;
					}
					if (items[2].IsSucess) {
						this.userInfo = items[2].Data;
						if (!this.userInfo.FullName) {
							this.dialogVisible = true;
						}
					}
				})
				.catch(() => {
					this.$message.error("网络异常，请刷新后再试");
				});
		},
	},
};
</script>
<style lang="scss">
.yhkgl_main {
	padding: 20px 20px 20px 0;
}

.yhkgl_main .czTable {
	margin-top: 0;
}

#yhkgl input::placeholder {
	color: #606266;
}

#yhkgl .name {
	font-size: 16px;
	font-weight: bold;
	color: black;
	line-height: 24px;
	margin-top: 20px;
}

#yhkgl .yue {
	font-size: 16px;
	font-weight: normal;
	color: #00772e;
	line-height: 24px;
}

/*右边*/
/*第二排*/
.two_box {
	width: calc(100%);
	padding: 0 20px;
	background-color: white;
}

.left_two_box {
	padding: 40px 20px;
	max-height: 240px;
}

/*表格抬头*/
.ykhgl_top_left .name,
.ykhgl_top_left .list {
	text-align: left;
	margin-left: 20px;
}

.ykhgl_top_left .name {
	color: #000000;
	font-size: 16px;
	line-height: 24px;
}

.ykhgl_top_left .list {
	color: #e9a400;
	font-size: 14px;
	line-height: 28px;
}

.ykhgl_top_left {
	background-color: #fff94e75;
	min-height: 160px;
}

/*底部*/
#yhkgl .bottom {
	height: 50px;
	border-radius: 5px;
	border: 1px solid #0e78c7;
	margin: 20px 0px 0 0px;
	display: flex;
	align-items: center;
	justify-content: space-between;
}

.close-icon {
	color: #0e78c7;
	font-size: 22px;
	margin-right: 20px;
}

.bottom_ts {
	text-align: left;
}

/*没有银行卡的*/
.none_card {
	text-align: center;
	font-size: 14px;
	color: #666;
}

.none_card_box {
	display: flex;
	justify-content: center;
	align-items: center;
	margin: 40px auto;
	color: #666;
}

.none_card .blue {
	padding: 8px 23px;
}

.bindCart .el-select {
	width: 100%;
}

.bindCart {
	margin-top: 20px;
	width: 50%;
}

/*表格样式*/
#yhkgl .el-dialog__body {
	padding: 0;
}

#yhkgl .el-dialog__footer {
	padding: 25px 0 60px;
	text-align: center;
}

#yhkgl .yhkgl_top {
	display: flex;
	justify-content: center;
	width: 100%;
	height: 150px;
	position: relative;
}

#yhkgl .add_title {
	width: 204px;
	height: 130px;
	margin-top: 10px;
	border-right: solid 1px #dddddd;
}

#yhkgl .add_title > img {
	display: block;
	width: 72px;
	height: 70px;
	margin: 10px auto 0;
	cursor: pointer;
}

#yhkgl .add_title > a {
	display: block;
	width: 106px;
	height: 28px;
	margin: 13px auto 0;
	background-color: #d86556;
	font-size: 12px;
	color: #ffffff;
	text-align: center;
	line-height: 28px;
	border-radius: 14px;
	cursor: pointer;
}

#yhkgl .wxts {
	font-size: 16px;
	color: #333;
}

#yhkgl .yhkgl_top .list {
	font-size: 14px;
	color: #666;
	line-height: 16px;
}

#yhkgl .wxts_text {
	display: flex;
	flex-direction: column;
	justify-content: space-around;
	height: 116px;
	width: 100%;
	padding-top: 10px;
}

#yhkgl .tips_bind {
	width: 22px;
	height: 22px;
	margin-left: 20px;

	.el-icon-warning-outline {
		font-size: 22px;
		color: #1e8edd;
	}
}

#yhkgl .bottom_ts_text {
	color: #0e78c7;
	font-size: 14px;
	font-weight: bold;
	margin-left: 28px;
}

#yhkgl .bottom_top {
	display: flex;
	align-items: center;

	.blue {
		margin-left: 10px;

		font-size: 14px;
		color: blue;
		text-decoration: underline;
		cursor: pointer;
	}
}
.lock {
	display: flex;
	justify-content: left;
	align-items: center;
	padding-left: 20px;
	font-size: 13px;
	.btn {
		display: inline-block;
		width: 110px;
		height: 32px;
		line-height: 32px;
		text-align: center;
		border: 1px solid #b0965d;
		font-size: 12px;
		font-weight: bold;
		border-radius: 3px;
		box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
		color: #fff;
		background: linear-gradient(to bottom, #b0965d 0, #b0965d 100%);
	}
	.lock_hint {
		margin-left: 10px;
		color: #666;

		a {
			text-decoration: none;
			color: #b0965d;
		}
	}
}
#yhkgl .notice {
	padding: 8px 10px;
	margin-bottom: 10px;
	border: 1px solid #f8e2b9;
	background-color: #fffdeb;
	color: #fb911f;
	font-size: 13px;
	span {
		margin-right: 8px;
	}
}
a.blue {
	margin-left: 10px;
	margin-right: 10px;
	font-size: 14px;
	color: blue;
	text-decoration: underline;
	cursor: pointer;
	font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/UserComps/yhkgl.vue